import React from "react";
import { VsiH4, VsiH5 } from "../../styled/App.styled";
import ErrorBoundaryFactory from "../ErrorBoundaryFactory";
import Img from "../../assets/images/login-hero.svg"
export default class ReportErrorBoundary extends ErrorBoundaryFactory {

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			// Only for catching larger report specific errors
			return (
				<>
					<VsiH4 style={{ textAlign: 'center'}}>Oops.. there's a problem with {this.props.title}, but we're working on it!</VsiH4>
					<VsiH5 style={{textAlign: 'center'}}>While we're fixing this one, try another report!</VsiH5>
					<div className={"d-flex flex-row justify-content-center"}>
						<img alt={"Generic VOI infrastructure"} src={Img} />
					</div>
				</>
			)
		}

		return this.props.children;
	}
}